"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _getOneDisplayValue = _interopRequireDefault(require("./getOneDisplayValue"));

var getDisplayValues = function getDisplayValues(_ref) {
  var defaultLanguage = _ref.defaultLanguage,
      display = _ref.display,
      keys = _ref.keys,
      language = _ref.language,
      rootObject = _ref.rootObject;
  return keys.map(function (key) {
    return (0, _getOneDisplayValue["default"])({
      key: key,
      display: display,
      language: language,
      defaultLanguage: defaultLanguage,
      rootObject: rootObject
    });
  });
};

var _default = getDisplayValues;
exports["default"] = _default;
//# sourceMappingURL=getDisplayValues.js.map